// Vite 3's `__vitePreload` rejection when a lazily-loaded chunk's CSS <link> fails to load.
const PRELOAD_CSS_MESSAGE_PATTERN = /^Unable to preload CSS for /;

// Failure shapes browsers use when a dynamic `import()` itself cannot be fetched/evaluated
// (e.g. the JS chunk was deleted from the server after an upgrade, same root cause class as
// a missing CSS asset).
const DYNAMIC_IMPORT_MESSAGE_PATTERN = /failed to fetch dynamically imported module|error loading dynamically imported module/i;

// Message-level form, for callers that only ever hold the message text (e.g. a captured
// telemetry exception) and would otherwise have to wrap it in a throwaway `Error`.
export function isPreloadErrorMessage(message: string): boolean {
  return PRELOAD_CSS_MESSAGE_PATTERN.test(message) || DYNAMIC_IMPORT_MESSAGE_PATTERN.test(message);
}

/**
 * Classifies whether an error/rejection is a Vite preload-CSS failure or a dynamic-import
 * fetch failure, both of which stem from a stale/missing hashed build asset. Pure: takes the
 * raw error and performs no side effects.
 */
export default function isPreloadError(error: unknown): boolean {
  if (!(error instanceof Error) || typeof error.message !== 'string') {
    return false;
  }

  return isPreloadErrorMessage(error.message);
}
